export default __webpack_public_path__ + "e8e6207294894e9d5043ec4f9560d0c9.png";